<template>
  <div>
    <!-- 返回 -->
    <div class="aiTitle">
      <div @click="$router.go(-1);" class="goBack">
        <i class="el-icon-back"></i>
        <span style="margin: 0 17px 0 5px;">返回</span>
        <span style="font-size: 16px;">{{ aiName }}</span>
      </div>
      <div @click="openHistoryProblem">
        <i class="iconfont icon-daohang"></i>
      </div>
    </div>
    <!-- 正文 -->
    <div>
      <!-- 进入页面时 -->
      <div class="mian" v-if="noPlomble">
        <div class="identification">
          <i class="iconfont icon-rengongzhinengjiejuefanganicon hello"></i>
          <p style="margin-top: 20px">你好 {{ userInfo.studentName }} ，我是{{ aiName }}</p>
        </div>
        <el-card class="box-card">
          <p class="common">常见问题</p>
          <ul v-if="commonProblem && commonProblem.length > 0">
            <li
              v-for="(itemPro,index) in commonProblem"
              :key="index"
              class="problemList commonList"
              @click="commonProblemAsk(itemPro.question)"
            >
              <!-- <p> -->
              <span style="color: #409EFF;">●</span>
              <p>{{ itemPro.question }}</p>
              <!-- </p> -->
            </li>
          </ul>
          <ul v-else style="color: #bbb;">暂无数据，可以输入您的问题开始问答！</ul>
        </el-card>
      </div>

      <!-- 开始询问问题时 -->
      <div class="chat-container" v-else ref="chatContainer">
        <div
          class="chat-message user-message"
          v-for="(message, index) in userMessage"
          :key="index"
          :class="{'user-message': message.role === 'user', 'ai-message': message.role === 'assistant'}"
        >
          <!-- 用户消息 -->
          <template v-if="message.role === 'user'">
            <p
              class="message-content"
              style="text-align: left; white-space:pre-wrap;"
            >{{ message.content }}</p>
            <el-avatar style="color: #000;">我</el-avatar>
          </template>
          <!-- AI消息 -->
          <template v-else-if="message.role === 'assistant'">
            <i class="iconfont icon-rengongzhinengjiejuefanganicon"></i>
            <div class="message-content markdown-content">
              <div v-if="message.loading" class="loading-dots">
                <span class="dot"></span>
                <span class="dot"></span>
                <span class="dot"></span>
              </div>
              <div v-else v-html="renderedMarkdown(message.content)"></div>
            </div>
          </template>
        </div>
      </div>
    </div>

    <!-- 底部输入框 -->
    <div class="bottomInput">
      <el-input
        v-model="stuPromble"
        type="textarea"
        placeholder="请输入您的问题"
        class="input"
        @focus="judgeInput"
        @keydown.native="handleKeydown"
      ></el-input>
      <i
        class="el-icon-s-promotion bottomIcon"
        :style="{color: (stuPromble.length > 0  && (recoverDataStatus == 2 || recoverDataStatus == null || recoverDataStatus == 3)) ? 'initial' : '#ccc'}"
        @click="sendAiMessage"
      ></i>
      <p v-if="restrictTips" style="color: red;">字数请在2~255之间</p>
    </div>
    <!-- 历史问题弹窗 -->
    <el-drawer
      title="历史会话"
      :visible.sync="drawer"
      direction="rtl"
      size="100%"
      :before-close="handleClose"
    >
      <div v-if="historyList.length > 0" @scroll="handleScroll" class="scroll-container">
        <div v-if="recentHistory.length > 0">
          <p class="createTime">最近七天</p>
          <ul class="drawerUl">
            <li
              v-for="(itemPro, index) in recentHistory"
              :key="'recent_' + index"
              class="problemList history"
              @click="aiChatMessage(itemPro.chatNumber)"
            >
              <p>{{ itemPro.title }}</p>
            </li>
          </ul>
        </div>

        <!-- 7天外数据 -->
        <div v-if="olderHistory.length > 0">
          <p class="createTime">其它</p>
          <ul class="drawerUl">
            <li
              v-for="(itemPro, index) in olderHistory"
              :key="'older_' + index"
              class="problemList history"
              @click="aiChatMessage(itemPro.chatNumber)"
            >
              <p>{{ itemPro.title }}</p>
            </li>
          </ul>
        </div>

        <div v-if="loading" class="loading">
          <i class="el-icon-loading"></i>正在加载...
        </div>
        <div v-if="hasMoreData && !loading" class="noMore">- 暂无更多数据 -</div>
      </div>
      <el-empty :image-size="200" v-else></el-empty>
    </el-drawer>
  </div>
</template>

<script>
import {mapState} from "vuex";
import axios from "axios";
import marked from "marked";

export default {
  data() {
    return {
      aiId: null,
      appId: null,
      aiName: '',
      messageQueue: [],
      processingMessage: false,
      commonProblem: [], //常见问题数组
      stuPromble: "",
      noPlomble: true, //常见问题 对话切换
      userMessage: [], //渲染对话
      drawer: false, //历史问题
      eventSource: null, //用于管理SSE连接
      currentPage: 1,
      pageSize: 20,
      totalCount: 0,
      firstRecord: true, //是否需要新建对话
      aiContent: "",
      isSSEConnected: false,
      sessionId: null,
      restrictTips: false, //限制input字数
      recoverDataStatus: null,
      loading: false, //下拉加载
      hasMoreData: false, // 是否还有更多数据
      historyList: [],
      recentHistory: [], // 7天内的数据
      olderHistory: [] // 7天外的数据
    };
  },
  created() {
    this.aiId = this.$route.query.aiId;
    this.appId = this.$route.query.appId;
    this.aiName = this.$route.query.aiName;
  },
  mounted() {
    document.title = this.aiName;
    //获取常见问题
    this.getListAICommonQuestion();
    //获取历史回话
    this.aiHistoryList();
    if (this.$route.query.home && this.$route.query.home == 'home') {
      this.drawer = true;
    }
  },
  computed: {
    ...mapState({
      userInfo: state => state.user.student
    })
  },
  watch: {
    userMessage() {
      this.scrollToBottom();
    }
  },
  methods: {
    // 将 Markdown 转换为 HTML
    renderedMarkdown(content) {
      return marked(content);
    },
    //打开历史对话
    openHistoryProblem() {
      this.drawer = true;
      // this.aiHistoryList()
    },
    //获取常见问题
    getListAICommonQuestion() {
      const options = {
        method: "GET",
        headers: {"content-type": "application/x-www-form-urlencoded"},
        params: {
          token: this.userInfo.token,
          aiId: this.aiId,
          appId: this.appId,
          pageSize: 6,
          current: 1,
          status: -1
        },
        url: "/constub/AI/commonQuestion/getListAICommonQuestion"
      };
      axios(options).then(res => {
        res = res.data;
        if (res && res.result.success) {
          this.commonProblem = res.data.results;
        } else {
          this.$alert(res.result.message, {
            confirmButtonText: "确定",
            showClose: false
          });
        }
      });
    },
    //获取历史对话
    aiHistoryList(isReset = false) {
      if (this.loading) return; // 防止重复加载
      this.loading = true; // 开始加载

      const options = {
        method: "GET",
        headers: {"content-type": "application/x-www-form-urlencoded"},
        params: {
          token: this.userInfo.token,
          aiId: this.aiId,
          appId: this.appId,
          pageSize: this.pageSize,
          current: this.currentPage,
          theme: "全部"
        },
        url: "/constub/AI/chat"
      };

      axios(options)
        .then(res => {
          res = res.data;
          this.loading = false; // 加载完成
          if (res && res.result.success) {
            this.totalCount = res.data.totalCount;
            if (isReset) {
              this.historyList = res.data.results;
            } else {
              this.historyList = [...this.historyList, ...res.data.results];
            }
            if (res.data.results.length < this.pageSize) {
              this.hasMoreData = true; // 标记数据加载完成
            }
            this.splitHistoryByTime(res.data.results);
            this.currentPage++;
          } else {
            this.$alert(res.result.message, {
              confirmButtonText: "确定",
              showClose: false
            });
          }
        })
        .catch(() => {
          this.loading = false;
        });
    },
    //创建对话
    createAsession(prompt) {
      const options = {
        method: "POST",
        headers: {"content-type": "application/json"},
        data: JSON.stringify({
          aiId: this.aiId,
          appId: this.appId,
          prompt: prompt,
          sessionId: ""
        }),
        url: `/constub/AI/chat?token=${this.userInfo.token}`
      };
      axios(options).then(res => {
        res = res.data;
        if (res && res.result.success) {
          //重置页码
          this.currentPage = 1;
          this.historyList = [];
          this.recentHistory = [];
          this.olderHistory = [];
          this.hasMoreData = false;
          this.aiHistoryList(true);


          this.firstRecord = false;
          this.chatNumber = res.data.chatNumber;
          this.stuPromble = res.data.title;
          this.sendAiMessage();
        } else {
          this.$alert(res.result.message, {
            confirmButtonText: "确定",
            showClose: false
          });
        }
      });
    },
    //发送消息 判断是否是第一条信息 是 创建对话 不是 发送消息
    sendAiMessage() {
      if (!this.stuPromble.trim() || this.recoverDataStatus === 1) return;
      if (
        this.stuPromble.trim().length < 2 ||
        this.stuPromble.trim().length > 255
      ) {
        this.restrictTips = true;
        return;
      }

      this.restrictTips = false;
      if (this.firstRecord) {
        this.createAsession(this.stuPromble);
      } else {
        this.recoverDataStatus = 1
        this.noPlomble = false;
        this.userMessage.push({role: "user", content: this.stuPromble});
        const options = {
          method: "POST",
          headers: {"content-type": "application/json"},
          data: JSON.stringify({
            aiId: this.aiId,
            appId: this.appId,
            chatNumber: this.chatNumber,
            prompt: this.stuPromble,
            sessionId: this.sessionId ? this.sessionId : ""
          }),
          url: `/constub/AI/chat/message?token=${this.userInfo.token}`
        };
        axios(options).then(res => {
          res = res.data;
          if (res && res.result.success) {
            this.stuPromble = "";
            this.userMessage.push({
              role: "assistant",
              content: "",
              loading: true
            });
            this.aiContent = ""
            this.messageQueue = []
            this.startSSEConnection(res.data.messageId, res.data.id);
            this.scrollToBottom();
          } else {
            this.$alert(res.result.message, {
              confirmButtonText: "确定",
              showClose: false
            });
          }
        }).catch(e => {
          this.recoverDataStatus = 2;
        });
      }
    },
    //建立SSE链接
    startSSEConnection(messageId, msgId) {
      if (!window.EventSource) {
        this.$alert("您的浏览器不支持 SSE，请使用支持 SSE 的浏览器。", {
          confirmButtonText: "确定",
          showClose: false
        });
        return;
      }

      let url = `/constub/AI/chat/completions?token=${this.userInfo.token}&conversationId=${messageId}&msgId=${msgId}`;
      //创建连接
      this.eventSource = new EventSource(url);
      // 监听服务器发送的消息
      this.eventSource.onopen = () => {
        console.log("SSE 连接成功");
      };

      this.eventSource.onmessage = async event => {
        // 只有在连接正常的情况下，才会触发 onmessage
        try {
          const data = JSON.parse(event.data);
          // this.recoverDataStatus = data.status;
          // data.status 1 回复中 2 成功 3 失败
          if (data.status == 3) {
            if (
              this.userMessage.length > 0 &&
              this.userMessage[this.userMessage.length - 1].role == "assistant"
            ) {
              this.userMessage[this.userMessage.length - 1].content =
                "请求失败，请重试！";
              this.userMessage[this.userMessage.length - 1].loading = false;
            } else {
              this.userMessage.push({
                role: "assistant",
                content: "请求失败，请重试！",
                loading: false
              });
            }
            this.scrollToBottom();
          }
          if (data.status == 2) {
            console.log("接收到结束状态，关闭连接");
            this.closeSSEConnection();
          }

          if (data.content) {
            this.sessionId = data.sessionId;
            this.userMessage[this.userMessage.length - 1].loading = false;
            // 更新 aiContent，并推送新的消息
            this.addToMessageQueue(data.content);
            // if (
            //   this.userMessage.length > 0 &&
            //   this.userMessage[this.userMessage.length - 1].role == "assistant"
            // ) {
            //   this.userMessage[this.userMessage.length - 1].content =
            //     data.content;
            //   this.userMessage[this.userMessage.length - 1].loading = false;
            // } else {
            //   this.userMessage.push({
            //     role: "assistant",
            //     content: data.content
            //   });
            // }
            // this.scrollToBottom();
          }
        } catch (error) {
          this.$alert("消息错误，请联系管理员！", {
            confirmButtonText: "确定",
            showClose: false
          });
          console.error("消息解析失败", error);
        }
      };
      //错误处理
      this.eventSource.onerror = error => {
        console.error("SSE 连接出错:", error);
        //提示
        this.$alert("消息错误，请联系管理员！", {
          confirmButtonText: "确定",
          showClose: false
        });
        if (this.eventSource.readyState === EventSource.CLOSED) {
          console.log("连接已关闭");
        } else if (this.eventSource.readyState === EventSource.CONNECTING) {
          console.log("连接正在尝试建立");
        }
        this.closeSSEConnection();
      };
    },
    //关闭SSE连接
    closeSSEConnection() {
      this.isSSEConnected = false;
      if (this.eventSource) {
        this.eventSource.close(); // 关闭 SSE 连接
        this.eventSource = null;
      }
    },
    // 添加消息到队列
    addToMessageQueue(content) {
      this.messageQueue.push(content);
      if (!this.processingMessage) {
        this.processNextMessage();
      }
    },
    // 处理队列中的下一条消息
    async processNextMessage() {
      if (this.messageQueue.length === 0) {
        this.processingMessage = false;
        this.recoverDataStatus = 2
        return;
      }
      this.processingMessage = true;
      const content = this.messageQueue.shift();
      await this.simulatedTypewriter(content);
      this.processNextMessage();
    },
    async simulatedTypewriter(dialogueContent) {
      // console.log("开始处理 simulatedTypewriter:", dialogueContent);
      return new Promise(async (resolve) => {
        if (
          this.userMessage.length === 0 ||
          this.userMessage[this.userMessage.length - 1].role !== "assistant"
        ) {
          this.userMessage.push({
            role: "assistant",
            content: "",
            loading: true,
          });
        }

        const aiContent = this.aiContent;
        // 找出两个字符串中较短的一个
        let minLength = Math.min(aiContent.length, dialogueContent.length);

// 从较短字符串的长度开始截取较长字符串的剩余部分
        let difference = dialogueContent.substring(minLength);
        this.aiContent = dialogueContent;
        const characters = difference.split('');
        for (const char of characters) {
          await this.delay(30); // 延迟控制逐字显示速度，可以根据需要调整
          this.userMessage[this.userMessage.length - 1].content += char;
        }
        // lastMessage.loading = false; // 渲染完成，取消 loading 状态
        this.scrollToBottom();
        resolve(); // 当前消息渲染完成，通知后续任务可以执行
      });
    },
    async delay(ms) {
      return new Promise(resolve => setTimeout(resolve, ms));
    },
    //获取聊天内容列表
    aiChatMessage(chatNumber) {
      const options = {
        method: "GET",
        headers: {"content-type": "application/x-www-form-urlencoded"},
        params: {
          token: this.userInfo.token,
          chatNumber: chatNumber
        },
        url: "/constub/AI/chat/message"
      };
      axios(options).then(res => {
        res = res.data;
        if (res && res.result.success) {
          this.drawer = false;
          this.noPlomble = false;
          this.userMessage = res.data;
          this.scrollToBottom();
        } else {
          this.$alert(res.result.message, {
            confirmButtonText: "确定",
            showClose: false
          });
        }
      });
    },

    //常见问题
    commonProblemAsk(problem) {
      this.stuPromble = problem;
      this.sendAiMessage();
    },
    //展示最新内容
    scrollToBottom() {
      this.$nextTick(() => {
        const chatContainer = this.$refs.chatContainer;
        if (chatContainer) {
          chatContainer.scrollTop = chatContainer.scrollHeight;
        }
      });
    },
    //关闭历史会话
    handleClose() {
      this.drawer = false;
    },
    //回车键发送 shift+enter 换行
    handleKeydown(event) {
      // 按下 Enter 键且未按下 Shift 键，发送消息
      if (event.key === "Enter" && !event.shiftKey) {
        event.preventDefault(); // 阻止默认的换行行为
        this.sendAiMessage();
      }
    },
    //解析历史回话日期
    splitHistoryByTime(data) {
      const now = new Date();
      const sevenDaysAgo = new Date(now.getTime() - 7 * 24 * 60 * 60 * 1000);
      // 将数据分为7天内和7天以外
      data.forEach(item => {
        const createTime = new Date(item.chatCreateTime);
        if (createTime >= sevenDaysAgo) {
          this.recentHistory.push(item); // 7天内
        } else {
          this.olderHistory.push(item); // 7天以外
        }
      });
    },
    //滚动加载更多
    handleScroll(event) {
      const container = event.target;
      const scrollTop = container.scrollTop; // 已滚动距离
      const scrollHeight = container.scrollHeight; // 滚动内容高度
      const clientHeight = container.clientHeight;
      if (
        scrollTop + clientHeight >= scrollHeight - 20 &&
        !this.loading &&
        !this.hasMoreData
      ) {
        this.aiHistoryList();
      }
    },
    //避免input框被键盘遮盖
    isIOS() {
      const u = navigator.userAgent;
      return !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/); // iOS 终端
    },
    judgeInput() {
      if (this.isIOS()) {
        const handleFocusIn = () => {
          if (
            document.activeElement.tagName === "INPUT" ||
            document.activeElement.tagName === "TEXTAREA"
          ) {
            setTimeout(() => {
              // 滚动到页面底部
              window.scrollTo(0, document.body.scrollHeight);
            }, 0);
          }
        };
        window.addEventListener("focusin", handleFocusIn);

        // 解绑事件，防止内存泄漏
        this.$once("hook:beforeDestroy", () => {
          window.removeEventListener("focusin", handleFocusIn);
        });
      } else {
        const handleResize = () => {
          if (
            document.activeElement.tagName === "INPUT" ||
            document.activeElement.tagName === "TEXTAREA"
          ) {
            setTimeout(() => {
              document.activeElement.scrollIntoView({behavior: "smooth"});
            }, 0);
          }
        };
        window.addEventListener("resize", handleResize);

        // 解绑事件，防止内存泄漏
        this.$once("hook:beforeDestroy", () => {
          window.removeEventListener("resize", handleResize);
        });
      }
    }
  }
};
</script>

<style scoped>
/deep/ .markdown-content > p,
/deep/ .markdown-content > h1,
/deep/ .markdown-content > h2,
/deep/ .markdown-content > h3,
/deep/ .markdown-content > h4,
/deep/ .markdown-content > h5,
/deep/ .markdown-content > dd,
/deep/ .markdown-content > dl,
/deep/ .markdown-content > dt,
/deep/ .markdown-content > span,
/deep/ .markdown-content > ul,
/deep/ .markdown-content > ol,
/deep/ .markdown-content > td,
/deep/ .markdown-content > li,
/deep/ .markdown-content > pre {
  display: contents !important;
}

.goBack {
  font-size: 15px;
}

.markdownIconContent:after {
  content: "✍";
  color: #000;
  margin-left: 3px;
  vertical-align: baseline;
}

.aiTitle {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.el-icon-s-operation {
  font-size: 22px;
}

.problemList {
  width: 97%;
  /* height: 30px; */
  color: #000;
  background-color: #d8d8d8;
  margin-bottom: 12px;
  padding: 5px 10px;
  border-radius: 13px;
  /* line-height: 31px; */
  /* overflow: hidden; */
  /* white-space: nowrap; */
}

.problemList p {
  margin-left: 10px;
  /* text-overflow: ellipsis;
  overflow: hidden;
  white-space: nowrap; */
  font-size: 14px;
}

.commonList {
  display: flex;
  align-items: center;
}

.common {
  text-align: center;
  margin-bottom: 10px;
  color: #000;
  font-size: 14px;
}

.mian {
  margin-top: 20px;
  display: flex;
  flex-direction: column;
  height: calc(100vh - 160px);
  justify-content: space-evenly;
}

.identification {
  align-self: center;
  display: flex;
  align-items: center;
  flex-direction: column;
  color: #a52a2a;
}

.identification p {
  font-size: 18px;
  margin-top: 8px;
}

.identification i {
  font-size: 54px;
}

.mian ul {
  max-height: 300px;
  overflow-y: auto;
  padding: 0;
  margin: 0;
}

/deep/ .el-input__icon {
  font-size: 30px;
  margin-right: 10px;
  transform: rotate(40deg);
}

/deep/ .el-textarea__inner {
  padding: 5px 45px 5px 15px;
  border-radius: 10px;
}

.bottomInput {
  position: fixed;
  bottom: 15px;
  width: 94%;
}

.input {
  position: relative;
}

.bottomIcon {
  position: absolute;
  right: 15px;
  top: 23%;
  font-size: 30px;
}

.history {
  background: #fff;
  border: 1px solid #bbb;
  padding: 4px 10px;
  height: 34px;
  line-height: 28px;
  overflow: hidden;
  white-space: nowrap;
}

.history p {
  margin-left: 10px;
  text-overflow: ellipsis;
  overflow: hidden;
  white-space: nowrap;
  font-size: 14px;
}

/deep/ .el-dialog--center {
  padding: 0;
}

/deep/ .el-dialog__body {
  padding: 15px 10px;
}

.chat-container {
  max-width: 100%;
  margin: 0 auto;
  padding: 10px 0;
  /* background-color: #f9f9f9; */
  border-radius: 8px;
  height: calc(100vh - 101px);
  overflow-y: auto;
}

.chat-message {
  display: flex;
  margin: 10px 0;
  align-items: flex-start;
}

.user-message {
  justify-content: flex-end;
}

.ai-message {
  justify-content: flex-start;
}

.message-content {
  max-width: 82%;
  padding: 10px 15px;
  border-radius: 15px;
  font-size: 14px;
  line-height: 1.5;
}

.user-message .message-content {
  background-color: #409eff;
  color: #fff;
  text-align: right;
  border-top-right-radius: 0;
}

.ai-message .message-content {
  background-color: #fff;
  color: #424242;
  text-align: left;
  border-top-right-radius: 15px;
  border-top-left-radius: 0;
}

.drawerUl {
  padding: 3px 18px;
}

/deep/ .el-drawer__header > :first-child {
  color: #000;
  font-size: 18px;
}

.icon-rengongzhinengjiejuefanganicon {
  font-size: 24px;
  margin-right: 8px;
  color: #a52a2a;
}

/deep/ .el-avatar {
  line-height: 20px;
  font-size: 18px;
  background: none;
  width: 25px;
  height: 20px;
}

.listTitle {
  margin: 0 0 10px 5px;
  font-size: 14px;
  font-weight: bold;
}

.loading-dots {
  display: inline-block;
  position: relative;
  width: 50px;
  height: 20px;
}

.dot {
  position: absolute;
  width: 10px;
  height: 10px;
  background-color: #999;
  border-radius: 50%;
  animation: loading 1.5s infinite ease-in-out;
}

.dot:nth-child(1) {
  left: 0;
  animation-delay: 0s;
}

.dot:nth-child(2) {
  left: 15px;
  animation-delay: 0.2s;
}

.dot:nth-child(3) {
  left: 30px;
  animation-delay: 0.4s;
}

@keyframes loading {
  0%,
  100% {
    transform: scale(0);
    opacity: 0.5;
  }
  50% {
    transform: scale(1);
    opacity: 1;
  }
}

.scroll-container {
  height: calc(100vh - 75px);
  overflow-y: auto;
  /* background: pink; */
}

.noMore {
  text-align: center;
  color: #ccc;
  font-size: 15px;
  margin-bottom: 20px;
}

.loading {
  text-align: center;
  color: #000;
  margin-bottom: 10px;
}

.loading i {
  margin-right: 5px;
}

.createTime {
  padding-left: 20px;
  font-size: 15px;
  font-weight: bold;
}
</style>
